export enum StorageKeys {
  Token = 'auth_token'
}
